import { useState } from "@hookstate/core";
import { state } from "./state";

export const useBidConfirmationModal = () => {
  return useState(state.confirmationModal);
};
